import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toggleButtonLabel: {
		id: 'polaris-lib-expandable-section.toggle-button-label',
		defaultMessage: 'Toggle',
		description: 'Label for button to expand/collapse the section',
	},
});
